import { IExternalImageSource } from "../../../domain/externalImage";

export class ExternalImageSource implements IExternalImageSource {
  constructor(private _patientCode: string, private _id: string, private _getToken: () => string) {
  }

  private get token(): string {
    return this._getToken();
  }
  
  get source(): string {
    return "/api/patient/" + this._patientCode + "/externalimage/" + this._id + "/image?token=" + this.token;
  }

  get thumbnailSource(): string {
    return "/api/patient/" + this._patientCode + "/externalimage/" + this._id + "/thumbnail?token=" + this.token;
  }
}
